import styled from '@emotion/styled'
import { sronly } from '../../styles/sronly'

const S = {}

S.Announce = styled.div`
  ${sronly}
`

export default S
